import { modals } from '@mantine/modals';
import axios from 'axios';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { isApiError } from 'src/types/api-error.types';

const UNKNOWN_ERROR = 'UNKNOWN_ERROR';

const ErrorProvider = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();

  const openInfoModal = useCallback(
    (errorCode: string) => {
      modals.openContextModal({
        modal: 'info',
        title: t('createEventForm.errorModal.title', 'Oups'),
        centered: true,
        innerProps: {
          content: t(`apiErrors.${errorCode}`),
          confirmText: t('createEventForm.errorModal.ok', 'OK'),
        },
      });
    },
    [t]
  );

  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      response => response,
      error => {
        if (error?.response?.status === 401) {
          return Promise.reject(error);
        }

        if (error && typeof error === 'object' && 'response' in error) {
          const response = error.response as { data?: unknown };
          if (isApiError(response.data)) {
            openInfoModal(response.data.code);
          } else console.error(UNKNOWN_ERROR, error.message);
        } else console.error(UNKNOWN_ERROR, error.message);

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptorId);
    };
  }, [openInfoModal]);

  return <>{children}</>;
};

export default ErrorProvider;
